/**
 * GENERATED FILE. Do not edit.
 *
 * Source: packages/shared/registry/components.json
 * Rebuild: bun run registry:build
 */

/** Every component the registry declares. */
export const COMPONENT_IDS = [
  'text.plain',
  'text.multiline',
  'text.phone',
  'number.plain',
  'number.stepper',
  'money.calculator',
  'date.picker',
  'boolean.switch',
  'select.chips',
  'reference.search_picker',
  'reference.multi_picker',
  'file.picker',
  'map.picker',
  'value.readonly',
  'lines.table',
] as const;

export type ComponentId = (typeof COMPONENT_IDS)[number];

/**
 * The floor. One per value type, fourteen for eighteen types, because a unit, a
 * time part, and a multi flag are props and not components. A primitive never
 * takes a breaking change and never carries a fallback.
 */
export const PRIMITIVE_COMPONENT_IDS = [
  'boolean.switch',
  'date.picker',
  'file.picker',
  'lines.table',
  'map.picker',
  'money.calculator',
  'number.plain',
  'reference.multi_picker',
  'reference.search_picker',
  'select.chips',
  'text.multiline',
  'text.phone',
  'text.plain',
  'value.readonly',
] as const;

export type PrimitiveComponentId = (typeof PRIMITIVE_COMPONENT_IDS)[number];

export function isComponentId(value: string): value is ComponentId {
  return (COMPONENT_IDS as readonly string[]).includes(value);
}
